import { useMemo } from 'react';
import { useListRecordsQuery } from '@platform/state/api';
import { useLabel } from '@platform/hooks/useLabel';
import { routes } from '@platform/core/lib/routes';
import type { IRecordListParams } from '@platform/core/types';
import type { IExpertItem } from './IExpertItem';
import type { IExpertSource } from './IExpertSource';

/** Скільки записів бере кожне джерело (прототип v4: по чотири). */
const PER_SOURCE = 4;
/** Порядок масиву записів прототипу — за номером (ws.records[k].slice(0, 4)). */
const PARAMS: IRecordListParams = { sort: 'code', pageSize: 10, facets: false };
const NONE: IExpertItem[] = [];

/** Модуль-джерело, чиї записи порад відкриваються на «Читанні» (прототип v4: стаття бази знань — tab: 'read'; експертні висновки — «Загальне»). */
const READ_MODULE = 'kb';

/** Перші чотири записи джерела порад у порядку номерів (як slice(0, 4) масиву прототипу), з назвою модуля-джерела й посиланням на запис. */
export function useSourceItems(ws: string, source: IExpertSource | undefined): IExpertItem[] {
  const label = useLabel();
  const { data } = useListRecordsQuery({ ws, rt: source?.rt ?? '', params: PARAMS }, { skip: !source });
  return useMemo(() => {
    if (!source || !data) return NONE;
    const name = label(source.module.name);
    return data.items.slice(0, PER_SOURCE).map((r) => ({ id: r.id, title: r.title, source: name, to: routes.record(source.module.key, source.rt, r.id, source.module.key === READ_MODULE ? 'read' : undefined) }));
  }, [data, source, label]);
}
